import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
import { Col, Form, Modal, ModalBody, Row, ModalHeader, ModalFooter } from "reactstrap";
import { html as beautifyHtml } from 'js-beautify';
import { getPrimaryButtonClass } from "helpers/sf_utils";
import { EDITOR_CLASS_NAME } from "helpers/sf_constants";

export const SECTION_NAMES = {
    REQUEST: "request",
    RESPONSE: "response",
}

const styles = {
    fontFamily: '"Courier New", Courier, monospace',
    fontSize: 14,
    outline: 0,
    backgroundColor: '#FFFFFF',
    minHeight: '584px',
}
const IntegrationTestEditConfigModal = ({ show: { active, payload }, setTestEditConfigModal, onClickCloseModal, onClickSubmitModal }) => {
    const [codeState, setCodeState] = useState();
    const [isValid, setValid] = useState(true);

    const beautifyValue = (value) => {
        if (typeof value === 'string') {
            if (value.trim().startsWith('{') || value.trim().startsWith('[')) {
                return JSON.stringify(JSON.parse(value), null, 4);
            } else {
                return beautifyHtml(value, { indent_size: 4 });
            }
        }
        return value;
    };
    useEffect(() => {
        setCodeState(beautifyValue(payload?.data) || '')
    }, [payload?.data])
    const textareaRef = useRef();
    const onSubmitEditModal = () => {
        setTestEditConfigModal({ active: false, payload: codeState });
        onClickSubmitModal(codeState, payload?.lead_type_id, payload?.product_type_id)
    }
    const closeModal = () => {
        setValid(true);
        onClickCloseModal();
    }
    return (
        <Modal size="xl" isOpen={active} toggle={onClickCloseModal} centered={true}>
            <ModalHeader>
                <span className="modal-title mt-0">
                    Edit Sample Lead
                </span>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={closeModal}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => {
                    e.preventDefault()
                    return false;
                }}>
                    <Row>
                        <Col md={12}>
                            <div style={{ height: "20px" }}>
                                <small className="font-size-14 text-danger ms-1 mb-1">{
                                    !isValid && (
                                        'Invalid JSON'
                                    )}
                                </small>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="sf-scrollbar px-1" style={{ maxHeight: "484px", overflowY: "scroll", overflowX: "hidden" }}>
                                <Editor
                                    value={(codeState)}
                                    onValueChange={code1 => {
                                        setCodeState(code1)
                                        try {
                                            JSON.parse(code1);
                                            setValid(true);
                                        } catch (error) {
                                            setValid(false);
                                        }
                                    }}
                                    highlight={code => {
                                        return highlight(code, languages.liquid)
                                            .split("\n")
                                            .map((line, i) => `<span ${EDITOR_CLASS_NAME}>${i + 1}</span>${line}`)
                                            .join("\n");
                                    }
                                    }
                                    textareaId="codeArea"
                                    padding={10}
                                    style={styles}
                                    className="editor"
                                    ref={textareaRef}
                                />
                            </div>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <div className="float-end mt-1">
                    <button className={`btn ${getPrimaryButtonClass()} me-2`} disabled={!isValid} onClick={onSubmitEditModal}>Save</button>

                    <button
                        type="button"
                        className="btn btn-light ms-2"
                        name="close"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

IntegrationTestEditConfigModal.propTypes = {
    onClickCloseModal: PropTypes.func,
    show: PropTypes.object,
}

export default IntegrationTestEditConfigModal;
